export const RECENT_DOC_API_CONSTANT = {
  RECENT_OFFICE_DOC_DATA: "/dashboard/doc/list/recent",
};
